import { render } from "./UploadImagens.vue?vue&type=template&id=6312f17c&scoped=true"
import script from "./UploadImagens.vue?vue&type=script&lang=js"
export * from "./UploadImagens.vue?vue&type=script&lang=js"

import "./UploadImagens.vue?vue&type=style&index=0&id=6312f17c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6312f17c"]])

export default __exports__